import { manifestService } from '@/services';

export const manifiestModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
    listFilters: {},
    manifest:{
      data: null,
      error: null,
    },
    newManifest:{
      data: null,
      status: null,
    },
    updateManifest:{
      data: null,
      status: null,
    },
    deleteManifest:{
      data: null,
      status: null,
    },
    manifestosExcel:{
      data: null,
      error: null,
    },
    uploadResource:{
      data: null,
      status: null,
    },
    manifestResources: {
      data: [],
      error: null
    },
    downloadResource:{
      data: null,
      fileName: '',
      status: null,
    },
    deleteResource:{
      data: null,
      fileName: '',
      status: null,
    },
    requestDeleteResource:{
      status: null,
      fileName: '',
    },
  }),
  mutations: {
    cancelRequest(state, entity) {
      state.requestDeleteResource.status = {
        canceled: true
      }
      state.requestDeleteResource.fileName = entity['name']
    },
    appendResource(state, entity) {
      state.manifestResources.status = {
        loaded: false
      }
      if (entity['tags']['Content'] == 'image') {
        entity['type'] = 'img'
      } else {
        entity['type'] = 'doc'
      }
      state.manifestResources.data.push(entity)
      state.manifestResources.status = {
        loaded: true
      }
    },
    popResource(state, fileName) {
      state.manifestResources.status = {
        loaded: false
      }
      const currentappendResources = [ ...state.manifestResources.data ]
      state.manifestResources.data = [ ...currentappendResources.filter(document => document['name'] != fileName) ]
      state.manifestResources.status = {
        loaded: true
      }
    },
    load(state,request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
      manifestService.getManifestos(request.pagination,request.filters)
        .then((res) => {
          state.list.data = res
        })
        .catch((error) => {
          state.list.data = null
          state.list.error = error
        });      
    },
    getManifest(state, id) {
      manifestService.getManifest(id)
        .then((res) => {
          state.manifest.data = res
        })
        .catch((error) => {
          state.manifest.data = null
          state.manifest.error = error
        });      
    },
    newManifest(state, body){
      manifestService.newManifest(body)
      .then((res) => {
        state.newManifest.data = res
        state.newManifest.status = {
          created: true,
        };
      })
      .catch((error) => {
        state.newManifest.data = null
        state.newManifest.status = {
          error,
        };
      }); 
    },
    updateManifest(state, body){
      manifestService.updateManifest(body, body._id)
      .then((res) => {
        state.updateManifest.data = { ...res }
        state.updateManifest.status = {
          updated: true
        }
      })
      .catch((error) => {
        state.updateManifest.data = null
        state.updateManifest.status = {
          error
        };
      }); 
    },
    deleteManifest(state, body){
      manifestService.deleteManifest(body._id)
      .then((res) => {
        state.deleteManifest.data = { ...res }
        state.deleteManifest.status = {
          deleted: true
        }
      })
      .catch((error) => {
        state.deleteManifest.data = null
        state.deleteManifest.status = {
          error
        };
      }); 
    },
    manifestosExcel(state, request){
      manifestService.getManifestosAsExcel(request.filters, request.language)
      .then((excel) => {
        state.manifestosExcel.data = excel
        state.manifestosExcel.error = null
      })
      .catch((error) => {
        state.manifestosExcel.data = null
        state.manifestosExcel.error = error
      });
    },
    loadResources(state, entityId) {
      manifestService.getResources(entityId)
        .then((res) => {
          let images = res['images'].map(image => {
            image['type'] = 'img'
            return image
          })
          let documents = res['documents'].map(document => {
            document['type'] = 'doc'
            return document
          })
          state.manifestResources.data = [ ...images, ...documents ]
          state.manifestResources.status = {
            loaded: true
          }
        })
        .catch((error) => {
          state.manifestResources.data = null
          state.manifestResources.status = {
            error
          };
        });      
    },
    uploadResource(state, request){
      manifestService.uploadResource(request.entityId, request.dataForm)
      .then((res) => {
        state.uploadResource.data = { ...res }
        state.uploadResource.status = {
          uploaded: true
        }
      })
      .catch((error) => {
        state.uploadResource.data = null
        state.uploadResource.status = {
          error: error
        };
      });
    },
    downloadResource(state, request){
      manifestService.downloadResource(request.entityId, request.fileName)
      .then((res) => {
        state.downloadResource.data = res
        state.downloadResource.fileName = request.fileName
        state.downloadResource.status = {
          downloaded: true
        }
      })
      .catch((error) => {
        state.downloadResource.data = null
        state.downloadResource.fileName = request.fileName
        state.downloadResource.status = {
          error: error
        };
      });
    },
    deleteResource(state, request){
      const { file } = request
      const fileName = file['name'].split('/')[2]
      manifestService.deleteResource(request.entityId, fileName)
      .then((res) => {
        state.deleteResource.data = { ...res }
        state.deleteResource.fileName = file['name']
        state.deleteResource.status = {
          deleted: true
        }
      })
      .catch((error) => {
        state.deleteResource.data = null
        state.deleteResource.fileName = file['name']
        state.deleteResource.status = {
          error: error
        };
      });
    }
  }
}